
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-alert_svg__clip0_1716_18208)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M23.69 19.049L13.847 2.722A2.168 2.168 0 0012 1.68c-.751 0-1.459.4-1.847 1.042L.31 19.05a2.16 2.16 0 00-.031 2.173 2.16 2.16 0 001.877 1.096h19.69a2.16 2.16 0 001.877-1.096 2.16 2.16 0 00-.031-2.173zm-1.329 1.405a.594.594 0 01-.517.302H2.155a.594.594 0 01-.508-.9l9.845-16.327A.597.597 0 0112 3.242c.207 0 .401.11.508.287l9.845 16.326c.11.183.113.413.008.599z"}}),_c('path',{attrs:{"d":"M12.007 8.108c-.594 0-1.058.32-1.058.885 0 1.725.203 4.204.203 5.929 0 .45.391.638.855.638.348 0 .841-.189.841-.638 0-1.725.203-4.204.203-5.93 0-.565-.478-.884-1.044-.884z"}}),_c('path',{attrs:{"d":"M12.022 16.56c-.638 0-1.117.508-1.117 1.117 0 .594.479 1.116 1.117 1.116.594 0 1.102-.522 1.102-1.116 0-.61-.508-1.116-1.102-1.116z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-alert_svg__clip0_1716_18208"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 -.001)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    